// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"82fd629c","895":"4a882a0f"}[chunkId] + ".chunk.js";
};